<template>
  <div
    class="message"
    :style="{ backgroundColor: bgColor, color: textColor }"
  >
    <p 
      v-if="animationTime"
      :style="{ '--time': animationTime, fontFamily: font, backgroundColor: bgColor, color: textColor }"
    >
      {{messages.join(' - ')}}
    </p>
  </div>
</template>
<script>
import axios from 'axios'
import { parseString } from 'xml2js'
export default {
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    xml: null, //'https://www.dviewcontent.com/message/result/_61ef6c20-7234-11ed-b4b3-452344c480f0.xml',
    messages: [],
    animationTime: '50s',
  }),
  computed: {
    bgColor () { return this.enterprise.BGColor },
    textColor () { return this.enterprise.Color},
    bgSecondaryColor () { this.enterprise.BGColorSecundary },
    textSecondaryColor () { this.enterprise.ColorSecundary },
    enterpriseID () { return this.enterprise.ID },
    font () { return this.enterprise.Font },
  },
  watch: {
    'enterprise.TotemMessage' (v) {
      this.xml = v
      this.getMessages()
    },
  },
  mounted () {
    this.xml = this.enterprise.TotemMessage
    this.getMessages()
  },
  methods: {
    getMessages () {
      if (!this.xml || this.xml.length === 0) return
      axios.get(this.xml)
        .then (response => {
          try {
            const that = this
            parseString (response.data, (err, results) => {
            // parsing to json
              that.messages = []
              that.messages = results.rss.channel.shift().item.map(item => {
                return item['description'].shift()
              })
              let time = ((that.messages.join(' - ').length /200) | 0)
              time = (time ? time : 1) * 25
              this.animationTime = `${time}s`
            })
          } catch (error) {
           console.log(error)
          }
        })
    },
  },
}
</script>
<style scoped>
.message {
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;  
  white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
}
p {
    display: inline-block;
    color: #FFF;
    padding-left: 100%;
    animation: move linear infinite;
    animation-duration: var(--time);
    font-size: 1.5rem;
    margin-top:20px;
}
@keyframes move {
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }
}
</style>

